export default {"src":"/_next/static/media/RespiratoryInfections.03340dfd.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};